/**
 * TexasIrons Personalization Form behavior + cart-add intercept.
 * Handles dynamic show/hide of letter slots based on count picker,
 * the "Skip personalization" opt-out, and the global cart-add
 * intercept that always navigates to /cart on success.
 */
(function () {
  function init(root) {
    if (root.dataset.tiInitialized === '1') return;
    root.dataset.tiInitialized = '1';

    var countPicker = root.querySelector('[data-ti-count-picker]');
    var letterGrid = root.querySelector('[data-ti-letter-grid]');
    var slots = root.querySelectorAll('[data-ti-slot]');
    var noPersoCheckbox = root.querySelector('[data-ti-no-perso]');
    var designRadios = root.querySelectorAll('[data-ti-design]');
    var childFieldsets = root.querySelectorAll('[data-ti-child]');

    function applyDesign(selectedId) {
      childFieldsets.forEach(function (fs) {
        var id = fs.dataset.tiChild;
        var match = id === selectedId;
        fs.hidden = !match;
        fs.disabled = !match;
        // Mark inputs in the visible fieldset as required (except the year field which is optional).
        fs.querySelectorAll('input[type="text"]').forEach(function (inp) {
          if (match) {
            inp.required = inp.name !== 'properties[Year]';
          } else {
            inp.required = false;
            inp.value = '';
          }
        });
      });
    }

    if (designRadios.length) {
      designRadios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) applyDesign(r.dataset.tiDesignId);
        });
      });
    }

    function applyCount(n) {
      if (!letterGrid) return;
      var count = parseInt(n, 10) || 0;
      letterGrid.hidden = count === 0;
      slots.forEach(function (input) {
        var slot = parseInt(input.dataset.tiSlot, 10);
        if (slot <= count) {
          input.hidden = false;
          input.disabled = false;
          input.required = !noPersoCheckbox || !noPersoCheckbox.checked;
        } else {
          input.hidden = true;
          input.disabled = true;
          input.required = false;
          input.value = '';
        }
      });
    }

    function applyNoPerso(active) {
      root.toggleAttribute('data-ti-no-perso-active', active);
      // Find every input/select that posts a properties[...] field, excluding the opt-out itself.
      var props = root.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
      props.forEach(function (el) {
        if (el === noPersoCheckbox) return;
        if (active) {
          // Remember this element's prior disabled state so we can restore correctly when the
          // user unchecks the opt-out (e.g. a hidden letter slot was already disabled and should stay so).
          if (el.dataset.tiPrevDisabled === undefined) {
            el.dataset.tiPrevDisabled = el.disabled ? '1' : '0';
          }
          if (el.dataset.tiPrevRequired === undefined) {
            el.dataset.tiPrevRequired = el.required ? '1' : '0';
          }
          el.disabled = true;
          el.required = false;
        } else {
          if (el.dataset.tiPrevDisabled !== undefined) {
            el.disabled = el.dataset.tiPrevDisabled === '1';
            delete el.dataset.tiPrevDisabled;
          }
          if (el.dataset.tiPrevRequired !== undefined) {
            el.required = el.dataset.tiPrevRequired === '1';
            delete el.dataset.tiPrevRequired;
          }
        }
      });
      // Also clear visible letter values when opting out (purely cosmetic — disabled inputs won't post anyway)
      if (active) {
        slots.forEach(function (i) { i.value = ''; });
      }
    }

    if (countPicker) {
      countPicker.addEventListener('change', function (e) { applyCount(e.target.value); });
      // Apply initial state
      applyCount(countPicker.value);
    }

    if (noPersoCheckbox) {
      noPersoCheckbox.addEventListener('change', function (e) { applyNoPerso(e.target.checked); });
    }

    // Disable the swatch grid's child fields until the user picks a design — prevents
    // the browser from validating fields belonging to designs the user hasn't chosen.
    if (childFieldsets.length && !designRadios.length) {
      // No radios but child fieldsets present? Edge case; leave as-is.
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ti-perso]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section re-renders (Shopify section editor)
  document.addEventListener('shopify:section:load', initAll);

  // -----------------------------------------------------------------
  // Character restriction for monogram letter slots.
  //
  // Letter inputs on products with custom.allowed_characters carry a
  // pattern="[...]" attribute (e.g. [A-Z&]). The HTML5 pattern is the
  // real gate — form.checkValidity() (called before every /cart/add.js
  // post above, and before accelerated-checkout) blocks an out-of-set
  // character even with JS disabled. This listener is progressive
  // enhancement: as the customer types, upper-case the value and strip
  // anything outside the allowed class, so the stored line-item property
  // is genuinely uppercase (not just displayed via text-transform) and
  // they get immediate feedback instead of an error only on submit.
  //
  // Delegated + capture-phase so it also covers p3 slots that are hidden
  // at init and revealed later by the count picker.
  // -----------------------------------------------------------------
  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('ti-perso__letter')) return;
      var pattern = input.getAttribute('pattern');
      if (!pattern) return;
      // Extract the char-class body from a "[...]" pattern.
      var m = pattern.match(/^\[(.*)\]$/);
      var classBody = m ? m[1] : null;
      if (!classBody) return;
      var stripRe;
      try {
        stripRe = new RegExp('[^' + classBody + ']', 'g');
      } catch (e) {
        return;
      }
      // Upper-case first (allowed set is capitals), then drop anything
      // outside it. Numbers, symbols, lowercase-with-no-uppercase-form, etc.
      var cleaned = input.value.toUpperCase().replace(stripRe, '');
      if (cleaned !== input.value) input.value = cleaned;
    },
    true // capture phase
  );

  // -----------------------------------------------------------------
  // Cart-add intercept — always navigate to /cart on success.
  //
  // The legacy site's behavior is "click Add to Cart, land on /cart".
  // Horizon's stock flow opens a drawer/notification instead and never
  // navigates, which leaves our server-rendered header counter
  // ({{ cart.item_count }} in sections/header.liquid) stale until the
  // next hard navigation. We replace Horizon's add-to-cart handling
  // entirely: capture-phase click → fetch /cart/add.js → window.location
  // = '/cart'. Gift-wrap-checked products still use the dual-add path
  // (main item + gift-wrap variant in one request).
  //
  // Why intercept the BUTTON CLICK, not the form's submit event?
  // Horizon's <product-form-component> wraps the form and listens for
  // clicks on the submit button (on:click="/handleSubmit") to do its
  // own fetch — it never fires a real form submit event. So we must
  // hook into the click in the CAPTURE phase, before Horizon's handler
  // gets a chance to run, and stop propagation so Horizon's drawer/
  // notification path never fires.
  //
  // Why type="submit" (not just any name="add")?
  // Quick-add buttons on collection cards use <button type="button"
  // name="add" on:click="quick-add-component/handleClick"> to OPEN a
  // variant-picker dialog — they don't add to cart. Narrowing to
  // type="submit" leaves quick-add's open-dialog click alone; the
  // real submit inside the opened dialog still hits our handler.
  //
  // Why look up the gift-wrap checkbox by document query, not form
  // descendant? The personalization block is rendered OUTSIDE the
  // cart-add <form> (in a sibling container), associated to the form
  // via the HTML form="<form_id>" attribute. checkbox.closest('form')
  // returns null even though FormData(form) DOES include the checkbox
  // value (HTML form-attribute association handles that). We match
  // the checkbox to the form by formId.
  // -----------------------------------------------------------------
  function findGiftWrapCheckboxForForm(form) {
    if (!form) return null;
    // 1) descendant lookup (cheap)
    var inside = form.querySelector('[data-ti-giftwrap]');
    if (inside) return inside;
    // 2) by formId association
    if (form.id) {
      var byForm = document.querySelector(
        '[data-ti-giftwrap][form="' + form.id + '"]'
      );
      if (byForm) return byForm;
    }
    // 3) fallback: any visible giftwrap checkbox on the page (single-PDP
    // assumption, which holds for Horizon's product page).
    return document.querySelector('[data-ti-giftwrap]');
  }

  function buildPayload(form, giftWrap) {
    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);
    if (!mainVariantId || isNaN(quantity) || quantity < 1) {
      throw new Error('missing main variant id or quantity');
    }
    var giftVariantId = giftWrap.dataset.giftwrapVariant;
    if (!giftVariantId) {
      throw new Error('missing data-giftwrap-variant on checkbox');
    }

    // Collect line-item properties (skipping the giftwrap checkbox itself —
    // we don't want "Add Gift Wrap: yes" stamped on the main product line).
    var properties = {};
    formData.forEach(function (value, key) {
      if (!key) return;
      if (key.indexOf('properties[') !== 0) return;
      if (!value) return;
      var propName = key.slice('properties['.length, -1);
      if (propName === 'Add Gift Wrap') return;
      properties[propName] = value;
    });

    return {
      items: [
        {
          id: parseInt(mainVariantId, 10),
          quantity: quantity,
          properties: properties,
        },
        {
          id: parseInt(giftVariantId, 10),
          quantity: quantity,
        },
      ],
    };
  }

  function postCartAdd(payload, form, restoreFn, errorAlert) {
    // Run native HTML5 validity check on the form (for required fields,
    // pattern matches, etc). If invalid, surface the form's own error
    // UI instead of silently posting bad data.
    if (form.checkValidity && !form.checkValidity()) {
      if (form.reportValidity) form.reportValidity();
      restoreFn();
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || err.message || 'Cart add failed');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('TI cart add failed:', err);
        restoreFn();
        alert(errorAlert);
      });
  }

  function dualAdd(form, giftWrap, restoreFn) {
    var payload;
    try {
      payload = buildPayload(form, giftWrap);
    } catch (err) {
      console.error('TI gift wrap intercept: ' + err.message);
      restoreFn();
      return;
    }
    postCartAdd(
      payload,
      form,
      restoreFn,
      "Sorry — could not add the gift wrap to your cart. " +
        "Please try again, or contact us at orders@texasirons.com."
    );
  }

  function singleAdd(form, restoreFn) {
    // Forward the form's own fields to /cart/add.js as a JSON `items`
    // payload so we can take over Horizon's submit and navigate to
    // /cart on success. Mirrors what Horizon's product-form-component
    // posts (variant id + quantity + line-item properties).
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);
    if (!variantId || isNaN(quantity) || quantity < 1) {
      console.error('TI single add: missing variant id or quantity');
      restoreFn();
      return;
    }
    var properties = {};
    formData.forEach(function (value, key) {
      if (!key) return;
      if (key.indexOf('properties[') !== 0) return;
      if (!value) return;
      var propName = key.slice('properties['.length, -1);
      properties[propName] = value;
    });
    var item = {
      id: parseInt(variantId, 10),
      quantity: quantity,
    };
    if (Object.keys(properties).length) item.properties = properties;
    // Forward selling_plan if Horizon's subscriptions block set one.
    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    postCartAdd(
      { items: [item] },
      form,
      restoreFn,
      "Sorry — could not add to your cart. " +
        "Please try again, or contact us at orders@texasirons.com."
    );
  }

  // Capture-phase click on any real cart-add submit button. Runs BEFORE
  // Horizon's <product-form-component> handler (because we use the
  // capture phase) and stops propagation so Horizon's drawer/
  // notification flow never fires.
  document.addEventListener(
    'click',
    function (event) {
      // type="submit" only — quick-add's <button type="button" name="add">
      // is for opening the variant dialog, not adding to cart.
      var btn = event.target.closest && event.target.closest(
        'button[type="submit"][name="add"]'
      );
      if (!btn) return;
      var form = btn.form || btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      // Intercept BEFORE Horizon's handlers run.
      event.preventDefault();
      event.stopImmediatePropagation();

      btn.disabled = true;
      var restore = function () { btn.disabled = false; };

      var giftWrap = findGiftWrapCheckboxForForm(form);
      if (giftWrap && giftWrap.checked) {
        dualAdd(form, giftWrap, restore);
      } else {
        singleAdd(form, restore);
      }
    },
    true // capture phase
  );

  // Fallback: also handle native form submit (covers cart-add forms
  // that fire a real submit event instead of click-handling).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest && event.target.closest(
        'form[action*="/cart/add"]'
      );
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var btns = form.querySelectorAll(
        'button[type="submit"], input[type="submit"]'
      );
      btns.forEach(function (b) { b.disabled = true; });
      var restore = function () {
        btns.forEach(function (b) { b.disabled = false; });
      };

      var giftWrap = findGiftWrapCheckboxForForm(form);
      if (giftWrap && giftWrap.checked) {
        dualAdd(form, giftWrap, restore);
      } else {
        singleAdd(form, restore);
      }
    },
    true
  );

  // Buy It Now / Shop Pay / Apple Pay / PayPal Express bypass the product
  // form's submit cycle entirely — Shopify's accelerated-checkout block
  // posts to /cart/add asynchronously via its own JS, which means the
  // capture-phase click + submit listeners above never fire for those
  // buttons. Without this listener, customers can check out with empty
  // required personalization fields. Run form.checkValidity() against the
  // associated <form> (personalization inputs are attached via the HTML5
  // `form=` attribute so they're included in validity check) and block
  // the click if anything is missing.
  document.addEventListener(
    'click',
    function (event) {
      var checkoutContainer = event.target.closest && event.target.closest(
        'shopify-accelerated-checkout, '
        + 'shop-pay-button, '
        + 'shopify-payment-terms, '
        + '.shopify-payment-button, '
        + '.shopify-payment-button__button, '
        + '[data-block-type="accelerated-checkout"], '
        + '[data-shopify="payment-button"]'
      );
      if (!checkoutContainer) return;

      var form = checkoutContainer.closest('form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      if (form.checkValidity && !form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.reportValidity) form.reportValidity();
      }
    },
    true // capture phase: run BEFORE Shopify's dynamic checkout JS
  );
})();
